<template>
	<a href="#" @click.prevent="goToHelp()" :class="linkClass">
		<font-awesome-icon icon="question-circle"></font-awesome-icon> 
		<span class="visible-lg-inline" v-if="disableText">
			{{ $t('MAIN_CONTENT.HelpButton.helpLink') }}
		</span>
		<modal :modal-title="modalTitle" :show="showModal" dialog-size="md" name="helpResourceModalBlocked" @close="closeModal()">
			<template slot-scope="modalProps">
				<p>
					<strong>
						{{ $t( 'MAIN_CONTENT.HelpButton.popupBlocked' ) }}
					</strong>
				</p>
				<p>
					{{ $t( 'MAIN_CONTENT.HelpButton.clickLinkMessage' ) }}
				</p>
				<p>
					<a :href='helpData.HELP_LINK' target='_blank'>
						{{ $t( 'MAIN_CONTENT.HelpButton.goToHelp' ) }}
					</a>
				</p>
				<p>{{ $t( 'MAIN_CONTENT.HelpButton.note' ) }}</p>
			</template>
			<template slot="footer">
				<button type="button" class="btn btn-transparent pull-right" @click="closeModal()">
					{{ $t('MAIN_CONTENT.commonContent.closeButton') }}
				</button>
			</template>
		</modal>
	</a>
</template>

<script>
import { mapGetters } from 'vuex';

import HelpResource from '../../api/Help';

import Modal from 'COMMONS/shared/Modal/Modal.vue';

export default {
	props: {
		linkClass: {
			type: String,
			default: ""
		},
		disableText: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			modalTitle: 'Pop Up Blocked',
			showModal: false,
			helpData: {
				HELP_LINK: '',
			},
		}
	},
	computed: {
		...mapGetters( [ 'profileLocale', 'adminLocale' ] )
	},
	components: {
		Modal,
	},
	methods: {
		closeModal() {
			this.showModal = false;
			$('body > div[name="helpResourceModalBlocked"]').prependTo(this.$el);
		},
		openModal() {
			this.showModal = true;
			$(this.$el).children('div[name="helpResourceModalBlocked"]').prependTo('body');
		},
		goToHelp() {
			const screenId = this.$route.meta.helpScreenId ? this.$route.meta.helpScreenId : '';

			let queryData = {
				screen_id: screenId,
				product_id: 'CWP2'
			};

			if( Object.keys( this.profileLocale ).length > 0 ) {
				if( !!this.profileLocale.LOCALE_CODE ) {
					if( this.profileLocale.LOCALE_CODE !== 'en-us' ) {
						queryData.product_id = `${queryData.product_id}_${this.profileLocale.LOCALE_CODE}`;
					}
				}
			}
			else if(Object.keys(this.adminLocale).length > 0){
				if( !!this.adminLocale.LOCALE_CODE ) {
					if( this.adminLocale.LOCALE_CODE !== 'en-us' ) {
						queryData.product_id = `${queryData.product_id}_${this.adminLocale.LOCALE_CODE}`;
					}
				}
			}


			const Help = new HelpResource({
				query: queryData
			});

			Help.get().then(() => {
				this.helpData = Help.getResponseData();
				let newWin = window.open( `${this.helpData.HELP_LINK}#cshid=${queryData.screen_id}`, '_blank' );
				let isBlocked = !newWin || newWin.closed || typeof newWin.closed == 'undefined';

				if( isBlocked ) {
					this.openModal(); 
				}

			});

		},
	}
}
</script>
